import { Action } from '@occc-app/rootRedux';

import types, { State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  locale: '',
  title: '',
  imageUrl: '',
  shortDescription: '',
  longDescription: '',
  terms: '',
  termsUrl: '',
  disclaimer: '',
  disclaimerUrl: '',
  error: null,
  errorMessages: [],
  id: '',
  dirty: false,
  requesting: true,
  submitting: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.MARKETING_CONTENT_COMPONENT_OK:
      const { id } = action;
      return {
        ...state,
        id,
        error: null,
        errorMessages: [],
        dirty: false,
      };
    case types.MARKETING_CONTENT_UPDATE:
      return {
        ...state,
        [action.key]: action.value,
        dirty: true,
      };
    case types.REQUEST_MARKETING_CONTENT:
      return {
        ...state,
        id: action.id,
        error: null,
        errorMessages: [],
        dirty: true,
      };
    case types.REQUEST_MARKETING_CONTENT_OK:
      return {
        ...state,
        ...action.marketingContent,
        error: null,
        errorMessages: [],
        dirty: false,
      };
    case types.REQUEST_MARKETING_CONTENTS_OK:
      return {
        ...state,
        requesting: false,
      };
    case types.RESET_INITIAL_MARKETING_CONTENT_STATE:
      return {
        ...state,
        ...action.marketingContent,
      };
    case offerTypes.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
  }
  return state;
}
